var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * @desc iframe操作
 * @author ruoxinhuang
 * @date 2021-09-09
 */
import { registryGlobalEventForce, setTitle as setTitleBridge } from '@tencent/vb-app-bridge';
import { isFusionBankApp } from '../index';
export function setTitle(text, color) {
    // 这个函数解决问题场景是 当 A页面用的setTitleBridge设置标题 通过iframe贷款了B页面 B页面用了window.document.title来这标题
    // 导致 A页面或者B页面之间要获取当前页面标题的时候 获取不到，因为app设置的标题和window.document.title是不通的，所以约定用这个函数来设置标题 ，如果没有特殊场景 可以忽略这个函数
    var targeWindow = window.top || window;
    if (isFusionBankApp) {
        setTitleBridge({ text: text, color: color || '#000' });
        // @ts-ignore
        targeWindow.currentPageTitleSetBySetTitleBridge = text;
    }
    else {
        // @ts-ignore
        targeWindow.document.title = text;
    }
}
export function getTitle() {
    // 这个函数解决问题场景是 当 A页面用的setTitleBridge设置标题 通过iframe贷款了B页面 B页面用了window.document.title来这标题
    // 导致 A页面或者B页面之间要获取当前页面标题的时候 获取不到，因为app设置的标题和window.document.title是不通的，所以约定用这个函数来设置标题 ，如果没有特殊场景 可以忽略这个函数
    var targeWindow = window.top || window;
    if (isFusionBankApp) {
        // @ts-ignore
        return targeWindow.currentPageTitleSetBySetTitleBridge || targeWindow.document.title;
    }
    else {
        return targeWindow.document.title;
    }
}
export function iframeOpen(url) {
    return __awaiter(this, void 0, void 0, function () {
        var iframeDom, container, currentIndex, curParame, originalTitle;
        return __generator(this, function (_a) {
            iframeDom = document.getElementById('iframeContract');
            if (!iframeDom) {
                iframeDom = document.createElement('iframe');
                container = document.getElementById('app').firstElementChild || document.body;
                container.appendChild(iframeDom);
                iframeDom.id = 'iframeContract';
                iframeDom.style.position = 'fixed';
                iframeDom.style.background = '#ffffff';
                iframeDom.style.top = '0';
                iframeDom.style.left = '0';
                iframeDom.style.bottom = '0';
                iframeDom.style.right = '0';
                iframeDom.style.zIndex = '100';
                iframeDom.width = '0.1';
                iframeDom.height = '0.1';
                iframeDom.frameBorder = '0';
            }
            currentIndex = window.location.href.indexOf('#');
            curParame = '';
            // 如果页面并没有用router 没有用hash 那么这里自动给加个hash 方便 拉起iframe返回的时候触发hashchange
            if (currentIndex < 0) {
                window.history.replaceState({
                    title: '',
                    url: '',
                }, '', '#/');
                curParame = '/';
                currentIndex = window.location.href.indexOf('#');
            }
            else {
                curParame = window.location.href.substr(currentIndex + 1);
            }
            // const curParame = currentIndex >= 0 ? window.location.href.substr(currentIndex + 1) : '';
            // 安卓的微信底下 当拉起iframe之后 按返回键 并不会返回到父页面，而是返回到父页面到上一个页面 所以这里加一个state
            window.history.pushState({
                title: '',
                url: '',
            }, '', "#".concat(curParame));
            originalTitle = getTitle();
            iframeDom.src = url;
            iframeDom.style.position = 'fixed';
            iframeDom.style.background = '#ffffff';
            iframeDom.style.top = '0';
            iframeDom.style.left = '0';
            iframeDom.style.bottom = '0';
            iframeDom.style.right = '0';
            iframeDom.style.zIndex = '100';
            iframeDom.width = '100%';
            iframeDom.height = '100%';
            iframeDom.frameBorder = '0';
            return [2 /*return*/, new Promise(function (resolve) {
                    function removeIframe(res, noClose) {
                        var iframeDomRemove = document.getElementById('iframeContract');
                        if (noClose) {
                            // 不关闭iframe直接调走，合同模块需求
                            setTimeout(function () {
                                resolve(res);
                            }, 60);
                        }
                        else {
                            if (iframeDomRemove) {
                                iframeDomRemove.remove();
                                window.removeEventListener('popstate', popStateCallBack, false);
                                // callBackFromChildIframe里面在remove之后 会有一步historyback的操作，为了先让back先执行这里 用延迟
                                setTimeout(function () {
                                    resolve(res);
                                }, 60);
                            }
                        }
                        // 恢复title
                        // @ts-ignore
                        if (originalTitle) {
                            // @ts-ignore
                            setTitle(originalTitle, '#000');
                        }
                        // 为了解决一个场景的bug： appwebview中打开页面A，A页面iframeopen了另外一个页面B，这时候页面B重新注册了app的onshow事件，然后页面B关闭的时候 页面A中的onshow事件实际上已经被页面B抢了，所以这时候当iframe页面关闭的时候 重新给A页面注册onshow事件
                        // 如果不这么做的后果是：当iframe关闭的时候 A页面继续invoke了一个weex的安全组件 会导致A页面无法触发onshow回调 整个流程终端了，目前贷款选择优惠券这个流程中出现了这个问题，所以修复这个问题
                        if (isFusionBankApp) {
                            registryGlobalEventForce();
                        }
                    }
                    function popStateCallBack(e) {
                        if (!e.state || !e.state.current || e.state.current.trim() == curParame.trim()) {
                            removeIframe({
                                code: -1,
                                message: 'back',
                            });
                        }
                    }
                    window.addEventListener('popstate', popStateCallBack, false);
                    window.callBackFromChildIframe = function (mes, noClose) {
                        removeIframe(mes, noClose);
                        // 解决pushstate带来的history问题 不要随便调整这里的顺序
                        history.back();
                    };
                })];
        });
    });
}
export function iframeSaveBack(res, noClose) {
    if (noClose === void 0) { noClose = false; }
    try {
        parent.window.callBackFromChildIframe(res, noClose);
    }
    catch (e) {
        history.back();
    }
}
